"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Icon_1 = require("../Icon");
/*eslint-disable */
/*tslint:disable */
var DigitalProductBadge = function (props) { return (React.createElement(Icon_1.default, tslib_1.__assign({ viewBox: "0 0 73 74" }, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M43.333 37.25L38 42.14V21h-2v21.14l-5.333-4.89-1.333 1.417 7.667 7 7.667-7zM22 51h30v2H22v-2z", className: "cls-2 content" })))); };
/*tslint:enable */
/*eslint-enable */
exports.default = DigitalProductBadge;
//# sourceMappingURL=DigitalProductBadge.js.map